import React from 'react';

const MarketPanelAdvanceDecline = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Advance Decline Trends Data</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="advance_decline_trends_data">
            <thead>
              <tr>
                <th>Number Of Scripts</th>
                <th>Volume</th>
                <th>Trend</th>
                <th>Turnover</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.number_of_scripts || '-'}</td>
                    <td>{item.volume || '-'}</td>
                    <td>{item.trend || '-'}</td>
                    <td>{item.turnover || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelAdvanceDecline; 